export default __webpack_public_path__ + "70616e6b3e39afd0107d1431206f2dbb.ogg";